import { Stack, Typography } from '@mui/material';
import ApexSLAChart from './ApexPriorityChart';
import EmptyFilter from './EmptyFilter';
import taskFiltersContext from '../../../use-task-filters';
import { taskStatusEnum } from 'types/store/taskEnums';

const InProgressStatusFilter: React.VFC = () => {
  const { inProgressRedrawKey, hasInProgressTasks, inProgressCounts, handlePriorityFilter } = taskFiltersContext.useController();

  if (!hasInProgressTasks) {
    return <EmptyFilter label="Tasks In Progress" />;
  }

  return (
    <Stack data-testid={'tasks-filter-status'}>
      <Typography variant="h5">Tasks In Progress</Typography>
      <ApexSLAChart
        key={`inProgressFilter${inProgressRedrawKey}`}
        priorityCounts={inProgressCounts}
        onPrioritySelected={(p) => handlePriorityFilter(taskStatusEnum.InProgress, p)}
      />
    </Stack>
  );
};

export default InProgressStatusFilter;
